import styles from './other.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import { FunctionComponent, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Title from '@/components/_custom/Title/title'
import { Construction } from '@mui/icons-material'
import LoggedOutNav from '@/components/Nav/LoggedOutNav/LoggedOutNav.tsx'

const Maintenance: FunctionComponent = () => {
    const { t } = useTranslation()

    const [counter, setCounter] = useState(59)

    useEffect(() => {
        const interval: NodeJS.Timeout = setInterval(() => {
            setCounter((prevCounter) => {
                if (prevCounter <= 1) {
                    removeServiceWorker()
                    return 59
                }
                return prevCounter - 1
            })
        }, 1000)

        return () => clearInterval(interval)
    }, [])

    return (
        <main>
            <LoggedOutNav hideRefresh />
            <div className={styles.Main}>
                <Construction className={styles.Icon} />
                <Title text={t('maintenanceOnGoing')} />
                <p>
                    {t('maintenanceTime')} {counter} {t('seconds')}
                </p>
                <ButtonTextIcon
                    type={'custom'}
                    customText={t('refresh')}
                    customIcon={<CachedIcon />}
                    onClick={removeServiceWorker}
                    className={styles.Button}
                />
            </div>
        </main>
    )
}

export default Maintenance
